import React, { useState } from 'react';
import { MapPin, Bell } from 'lucide-react';
import addTask from "../images/addTask.png";
const CalendarPage = () => {
  const [tasks, setTasks] = useState([
    {
      id: 1,
      address: "R823+FFM, Baidyabati - Tarkeshwar - Champadanga Rd, Champsara, West Bengal 712222, India",
      latitude: "22.80109890",
      longitude: "88.30334580",
      createdAt: "Mon, Jun 30, 2025 • 8:47 PM"
    },
    {
      id: 2,
      address: "R823+FFM, Baidyabati - Tarkeshwar - Champadanga Rd, Champsara, West Bengal 712222, India",
      latitude: "22.80109830",
      longitude: "88.30334250",
      createdAt: "Mon, Jun 30, 2025 • 8:45 PM"
    }
  ]);

  return (
    <div className="h-full bg-[#2f3e51] flex flex-col">
      {/* Top Header */}
      <div className="w-full bg-sky-400 text-white py-3 px-6 flex justify-between items-center text-lg font-bold flex-shrink-0">
        <span>Daily Task</span>
        <div className="bg-black bg-opacity-30 rounded-xl p-2">
          <Bell className="w-5 h-5 text-white" />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center px-4 overflow-auto">
        {/* Task Cards */}
        {tasks.map((task) => (
          <div key={task.id} className="bg-white rounded-xl p-4 shadow-md mt-6 w-full max-w-md">
            <div className="flex justify-between items-start">
              <div className="flex-1 pr-4">
                <p className="text-gray-800 text-sm leading-relaxed mb-3">
                  {task.address}
                </p>
                
                <div className="space-y-1">
                  <p className="text-sm">
                    <span className="text-gray-700 font-medium">latitude :</span>
                    <span className="text-red-500 font-medium ml-2">{task.latitude}</span>
                  </p>
                  
                  <p className="text-sm">
                    <span className="text-gray-700 font-medium">longitude :</span>
                    <span className="text-red-500 font-medium ml-2">{task.longitude}</span>
                  </p>
                  
                  <p className="text-sm">
                    <span className="text-gray-700 font-medium">Created at :</span>
                    <span className="text-red-500 font-medium ml-2">{task.createdAt}</span>
                  </p>
                </div>
              </div>
              
              <div className="ml-2">
                <div className="w-20 h-16 rounded-xl border-2 border-sky-400"></div>
              </div>
            </div>
          </div>
        ))}

        {/* Add New Task */}
        <button className="bg-white rounded-xl p-8 shadow-md mt-6 w-full max-w-md flex flex-col items-center justify-center">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4">
            <img
                src={addTask}
                
                className="w-full h-full object-cemter"
              />
          </div>
          <span className="text-gray-700 font-semibold text-lg">Add New Task</span>
        </button>
      </div>
    </div>
  );
};

export default CalendarPage;